import { Space, Dropdown, Menu, Row, Col, ConfigProvider, Radio, RadioChangeEvent } from "antd";
import { DownOutlined, TagsOutlined, DollarOutlined } from '@ant-design/icons';
import fa_IR from "antd/lib/locale/fa_IR";
import { ColumnsType } from "antd/lib/table";
import { useState, useEffect } from "react";
import { getRequestLabSupport, getRequestLabParsicUser, getRequestLabisLabUser, getLabInstallerItems } from "../../../api/api";
import CustomTable from "../../../components/_common/Table";
import { useAppSelector } from "../../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject } from "../../../services/toast.notification";
import { LabListContainer } from "../../financial/style";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import { SendCabledialog } from "./DeliveryInstall​";
import { RequestVmachineModal } from "./RequestVmachine";
import { Factor } from "./factor";
import { AssignInstallerDialogRequestLab } from "./AssignInstaller";

const RequestLabUserLab = () => {
    const [showSendCableDialog, setshowSendCableDialog] = useState(false);
    const [showSendMachin, setShowMachinDialog] = useState(false);
    const [showFactor, setShowFactor] = useState(false);
    const [showAssignInstallerDialog, setAssignInstaller] = useState(false);

    const [sendLabId, setLabId] = useState({ labId: '0' });
    const [assignInstaller, setInstaller] = useState({ labId: '0' });

    const [sendCablePayload, setSendCableDialogPayload] = useState({ cableRequestId: 0, machineInstallRequestId: 0, labId: 0 });
    const [sendMobile, setMobile] = useState({ mobile: '0' });
    const myStore = useAppSelector((state) => state)
    const [isLoading, setIsLoading] = useState(true);
    const [financialList, setFinancialList] = useState<any[]>([]);

    const [debtor, setdebtor] = useState(0);
    const [creditor, setCreditor] = useState(0);
    const [reminder, setReminder] = useState(0);

    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const columns: ColumnsType<any> = [

        {
            title: 'عملیات', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },

        { title: 'نام آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
        { title: 'شماره موبایل', dataIndex: 'str_MobileNumber', key: 'str_MobileNumber' },
        { title: 'تاریخ شروع نرم افزار', dataIndex: 'str_StartUsingSoftwareDate', key: 'str_StartUsingSoftwareDate' },
        { title: 'استان', dataIndex: 'str_StateName', key: 'str_StateName' },
        { title: 'ایمیل', dataIndex: 'str_Email', key: 'str_Email' },
        { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status' },
        { title: 'تعداد کامپیوتر', dataIndex: 'int_TotalNumberofComputers', key: 'int_TotalNumberofComputers' },
        { title: 'آدرس', dataIndex: 'str_Address', key: 'str_Address' },
        { title: 'تلفن مستقیم', dataIndex: 'str_DirectTel', key: 'str_DirectTel' },
        { title: 'کد اقتصادی', dataIndex: 'str_Economicode', key: 'str_Economicode' },
        { title: ' موسس', dataIndex: 'str_TaxFullNameOwnernationalCode', key: 'str_TaxFullNameOwnernationalCode' },
        { title: 'شناسه ملی', dataIndex: 'str_TaxnationalCode', key: 'str_TaxnationalCode' },
        { title: ' تایید کننده مالی ', dataIndex: 'str_FinancialApproveId', key: 'str_FinancialApproveId' },
        { title: 'تاریخ تایید مالی ', dataIndex: 'financialApproveDateTime', key: 'financialApproveDateTime' },
        { title: ' ژنتیک', dataIndex: 'str_IsGenetics', key: 'str_IsGenetics' },
        { title: 'موبایل مدیر', dataIndex: 'str_ManagerMobile', key: 'str_ManagerMobile' },
        { title: 'پاتولوژی', dataIndex: 'str_Patolozhi', key: 'str_Patolozhi' },
        { title: 'کدپستی', dataIndex: 'str_PostalCode', key: 'str_PostalCode' },
        { title: 'نصاب', dataIndex: 'centeralUserInstaller', key: 'centeralUserInstaller' },
        { title: 'تاریخ تکمیل نصب  ', dataIndex: 'str_CenteralInstallerDateTime', key: 'str_CenteralInstallerDateTime' },
        { title: 'نرم افزار فعلی', dataIndex: 'str_CurrentSoftware', key: 'str_CurrentSoftware' },
        { title: 'آنتی ویروس', dataIndex: 'str_VirusSoftwareName', key: 'str_VirusSoftwareName' },
        { title: 'تاریخ درخواست', dataIndex: 'requestDateTime', key: 'requestDateTime' },
    ];

    const [valueWorke, setValueWork] = useState(2);
    
    const onChange = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        setValueWork(e.target.value);

        loadDataSupport(getFirstDate(), getLastDate(), e.target.value)

    };

    const SendDeliverryInstall = (id: number, machineInstallRequestId: number, labId: number) => {

        setshowSendCableDialog(true);
        loadInstallerItems(labId);
        setSendCableDialogPayload((values: any) => ({
            ...values,
            cableRequestId: id,
            machineInstallRequestId: machineInstallRequestId,
            labId: labId
        }));
    }

    const SendNewFactor = (requestId: any, labId: any) => {

        setShowFactor(true);
        setLabId((values: any) => ({
            ...values,
            labId: Number(labId),
            requestId: requestId
        }));
    }

    const SendNewInstaller = (item: any) => {
        setAssignInstaller(true);
        setInstaller((values: any) => ({
            ...values,
            requestId: item.prk_installLabRequest_AutoID
        }));
    }

    const SendRequestVmachine = (mobileNumber: any, id: any, labId: any, frk_CenteralInstallerUserID: any) => {

        setShowMachinDialog(true);

        setMobile((values: any) => ({

            ...values,
            mobile: mobileNumber,
            prk_installLabRequest_AutoID: id,
            labId: labId,
            frk_CenteralInstallerUserID: frk_CenteralInstallerUserID
            // machineInstallRequestId:machineInstallRequestId,
        }));

    }
    const menu = (record: any) => (

        <Menu
            items={[
                {
                    key: "1",
                    label: "تحویل نصب ",
                    onClick: () => SendDeliverryInstall(record.prk_AndriodLab_AutoID, record.frk_MachineInstallRequestID,
                        record.prk_AndriodLab_AutoID),
                    // style:{'display':myStore.auth.loginType=='lab'? 'none':''},
                    //  disabled:!(myStore.auth.loginType === 
                    //'parsicuser' && record.bill===0 && record.bit_HaveInvoice===0
                    // && record.str_Amount != "0")
                    // disabled:(record.frk_CenteralInstallerUserID==0)  
                },
                {
                    key: "2",
                    label: " درخواست آنالایزر",
                    onClick: () => SendRequestVmachine(record.str_MobileNumber, record.prk_installLabRequest_AutoID, record.prk_AndriodLab_AutoID, record.frk_CenteralInstallerUserID),
                    icon: <TagsOutlined />,
                    // disabled:(record.frk_CenteralInstallerUserID==0) 
                    //disabled:(false)
                    // disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill===0 && record.bit_HaveInvoice===1 && record.str_Amount != "0") 

                },
                {
                    key: "3",
                    label: " ثبت فاکتور",
                    onClick: () => SendNewFactor(record.prk_installLabRequest_AutoID, record.prk_AndriodLab_AutoID),
                    icon: <DollarOutlined />,
                    style: {
                        'display': (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser') ?
                            'none' : (myStore.auth.loginType == 'parsicuser' && myStore.auth.manager == false) ? 'none' : ''
                    },
                    //  disabled:(record.frk_CenteralInstallerUserID==0) 
                    disabled: (true)
                },
                {
                    key: "4",
                    label: " تعیین نصاب",
                    onClick: () => SendNewInstaller(record),
                    // disabled:(record.frk_CenteralInstallerUserID!=0) 
                    disabled: (true)
                },

            ]}
        />
    )

    useJalaliLocaleListener();

    useEffect(() => {

        loadFinancialBalance(0)

    }, [])

    const loadFinancialBalance = (firstDate: any = undefined, lastDate: any = undefined, byFinancial: any = undefined) => {


        if (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser')
            loadDataLabUser();
        // manager":false,
        else if (myStore.auth.loginType == 'parsicuser' && !myStore.auth.manager)
            loadDataParsicUser();
        else
            // همه0
            // انجام داده 1
            // مانده 2
            // دیفالت 2
            //byFinancial==  (0 == all 1 == work 2==)
            loadDataSupport(firstDate, lastDate, byFinancial);

    }
    
    const loadDataSupport = (firstDate: any = undefined, lastDate: any = undefined
        , byFinancial: any = undefined) => {

        setIsLoading(true);

        getRequestLabSupport(firstDate ? firstDate : getFirstDate(),
            lastDate ? lastDate : getLastDate(), byFinancial ? byFinancial : 2)
            .then((result: any) => {

                setFinancialList(result.data.data);
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const loadDataParsicUser = () => {

        setIsLoading(true);

        getRequestLabParsicUser(myStore.auth.userId)
            .then((result: any) => {

                setFinancialList(result.data.data);
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const loadInstallerItems = (labId:number) => {

        getLabInstallerItems(0,labId)
            .then((result: any) => {
                setSendCableDialogPayload((values: any) => ({
                    ...values,
                    installItems:result.data.data
                }));
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

      

    }

    const loadDataLabUser = () => {

        setIsLoading(true);

         getRequestLabisLabUser(myStore.auth.userId)
            .then((result: any) => {

                setFinancialList(result.data.data);
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const briefCalculator = (list: any) => {

        if (list != undefined) {

            let value: number = 0;
            let debt: number = 0;
            let pay: number = 0;

            setdebtor(0);
            setCreditor(0);
            setReminder(0);


            list.forEach((element: any) => {
                element.bill === 1 ? debt = debt + element.int_Amount : pay = pay + element.int_Amount;
            });


            setdebtor(debt);
            setCreditor(pay);
            setReminder(debt - pay);

        }
        else {
            setdebtor(0);
            setCreditor(0);
            setReminder(0);
        }

    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])
        loadFinancialBalance(dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD'));
    }

    const getFirstDate = () => {
        return firstDate ? firstDate.format('YYYY-MM-DD') : undefined
    }

    const getLastDate = () => {
        return lastDate ? lastDate.format('YYYY-MM-DD') : undefined
    }

    return (
        <>
            <LabListContainer>
                {(() => {
                    // (myStore.auth.loginType!="lab"
                    // && myStore.auth.loginType!="parsicuser"
                    if (myStore.auth.loginType == "Support" ||
                        (myStore.auth.loginType == "parsicuser" &&
                            myStore.auth.manager == true)) {
                        return <Row>
                            <Col>
                                <Radio.Group
                                    style={{ marginTop: '15px' }}
                                    onChange={onChange} value={valueWorke}>
                                    <Radio value={2}> مانده </Radio>
                                    <Radio value={1}>  انجام داده</Radio>
                                    <Radio value={0}>  همه </Radio>
                                </Radio.Group>
                            </Col>
                            <Col>
                                <>
                                    <div className="calender">
                                        <ConfigProvider locale={fa_IR} direction="rtl">
                                            <JalaliLocaleListener />
                                            <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any, info: any) => onChangeDatePicker(dates, dateStrings, info)} />
                                        </ConfigProvider>
                                    </div>

                                </>
                            </Col>
                        </Row>
                    }
                })()}

                <SendCabledialog
                    visible={showSendCableDialog}

                    onSubmit={() => console.log(true)}
                    onCancel={() => { setshowSendCableDialog(false); loadFinancialBalance(0); }}
                    payLoad={sendCablePayload}
                    setShowDialog={() => { setshowSendCableDialog(false); loadFinancialBalance(0); }}
                />

                {(() => {
                    if (showAssignInstallerDialog) {
                        return <AssignInstallerDialogRequestLab
                            visible={showAssignInstallerDialog}
                            onSubmit={() => console.log(true)}
                            onCancel={() => { setAssignInstaller(false); loadFinancialBalance(0); }}
                            payLoad={assignInstaller}
                            setShowDialog={(value) => setAssignInstaller(value)}
                        />
                    }
                })()}
                {(() => {
                    if (showFactor) {
                        return <Factor
                            visible={showFactor}
                            onSubmit={() => console.log(true)}
                            onCancel={() => { setShowFactor(false); loadFinancialBalance(0); }}
                            payLoad={sendLabId}
                            setShowDialog={(value) => setShowFactor(value)}
                        />
                    }
                })()}

                {(() => {
                    if (showSendMachin) {
                        return <RequestVmachineModal
                            visible={showSendMachin}

                            onSubmit={() => console.log(true)}
                            onCancel={() => { setShowMachinDialog(false); loadFinancialBalance(0); }}
                            payLoad={sendMobile}
                            setShowDialog={() => { setShowMachinDialog(false); loadFinancialBalance(0); }}
                        />
                    }

                })()}

            </LabListContainer>
            <Row>
                <CustomTable

                    columns={columns} data={financialList}
                    isloading={isLoading} onAddClick={undefined} permission={true} />
            </Row>
        </>
    );
}
export default RequestLabUserLab